import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
import { File02Icon, Film01Icon, Image01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'fileIcon',
    props: {
        file: {}
    },
    setup(__props) {
        const props = __props;
        function identifyFileType(filename) {
            // Function to get the file extension
            function getFileExtension(filename) {
                const parts = filename.split('.');
                return parts.length > 1 ? parts.pop().toLowerCase() : '';
            }
            // List of common image and video extensions
            const imageExtensions = [
                'jpg',
                'jpeg',
                'png',
                'gif',
                'bmp',
                'tiff',
                'svg',
                'webp',
            ];
            const videoExtensions = ['mp4', 'avi', 'mov', 'mkv', 'flv', 'wmv', 'webm'];
            // Get the file extension
            const extension = getFileExtension(filename);
            // Determine the file type
            if (imageExtensions.includes(extension)) {
                return 'image';
            }
            else if (videoExtensions.includes(extension)) {
                return 'video';
            }
            else {
                return 'other';
            }
        }
        const fileType = computed(() => { var _a; return identifyFileType((_a = props.file) === null || _a === void 0 ? void 0 : _a.name); });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (fileType.value === 'image')
                    ? (_openBlock(), _createBlock(_unref(Image01Icon), {
                        key: 0,
                        class: "w-4 h-4"
                    }))
                    : _createCommentVNode("", true),
                (fileType.value === 'video')
                    ? (_openBlock(), _createBlock(_unref(Film01Icon), {
                        key: 1,
                        class: "w-4 h-4"
                    }))
                    : _createCommentVNode("", true),
                (fileType.value === 'other')
                    ? (_openBlock(), _createBlock(_unref(File02Icon), {
                        key: 2,
                        class: "w-4 h-4"
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
